import { ActiveLinkStyles } from "components/Navbar/Navbar.styled";
import styled from "styled-components";
import theme from "theme";
import Avatar from "components/Avatar";

export const Menu = styled.div`
    display: none;

    @media (${theme.breakpoints.tabletL}) {
        display: block;
    }
`;

export const HamburgerButton = styled.button<{
    menuOpen: boolean;
}>`
    display: none;
    @media (${theme.breakpoints.tabletL}) {
        ${theme.mixins.flexCenter};
        position: relative;
        z-index: 10;
        border: 0;
        background-color: transparent;
        color: ${theme.colors.white};
        text-transform: none;
        transition-timing-function: linear;
        transition-duration: 0.15s;
        transition-property: opacity, filter;
        height: 100%;
    }

    .ham-box-inner {
        position: absolute;
        top: 50%;
        right: 0;
        width: 25px;
        height: 1.5px;
        border-radius: 4px;
        transition-duration: 0.22s;
        transition-property: transform;
        transition-delay: ${(props) => (props.menuOpen ? `0.12s` : `0s`)};
        transform: rotate(${(props) => (props.menuOpen ? `225deg` : `0deg`)});
        transition-timing-function: cubic-bezier(
            ${(props) =>
                props.menuOpen
                    ? `0.215, 0.61, 0.355, 1`
                    : `0.55, 0.055, 0.675, 0.19`}
        );
        background-color: ${(props) =>
            props.menuOpen ? theme.colors.white : theme.colors.purple.primary};

        &:before,
        &:after {
            content: "";
            display: block;
            position: absolute;
            left: auto;
            right: 0;
            width: 30px;
            height: 1.5px;
            border-radius: 4px;
            transition-timing-function: ease;
            transition-duration: 0.15s;
            transition-property: transform;
            background-color: ${(props) =>
                props.menuOpen
                    ? theme.colors.white
                    : theme.colors.purple.primary};
        }
        &:before {
            width: ${(props) => (props.menuOpen ? `100%` : `25px`)};
            top: ${(props) => (props.menuOpen ? `0` : `-8px`)};
            opacity: ${(props) => (props.menuOpen ? 0 : 1)};
            transition: ${({ menuOpen }) =>
                menuOpen
                    ? "top 0.1s ease-out, opacity 0.1s ease-out 0.12s"
                    : "top 0.1s ease-in 0.25s, opacity 0.1s ease-in"};
        }
        &:after {
            width: ${(props) => (props.menuOpen ? `100%` : `25px`)};
            bottom: ${(props) => (props.menuOpen ? `0` : `-8px`)};
            transform: rotate(${(props) => (props.menuOpen ? `-90deg` : `0`)});
            transition: ${({ menuOpen }) =>
                menuOpen
                    ? "bottom 0.1s ease-out"
                    : "bottom 0.1s ease-in 0.25s"};
        }
    }
`;

export const HamburgerButtonBox = styled.div`
    display: inline-block;
    position: relative;
    width: 30px;
    height: 24px;
`;

export const Sidebar = styled.aside<{
    menuOpen: boolean;
}>`
    display: none;
    @media (${theme.breakpoints.tabletL}) {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100vh;
        outline: 0;
        background-color: ${theme.colors.purple.primary};
        z-index: 9;
        transform: translateX(${(props) => (props.menuOpen ? 0 : 100)}vw);
        visibility: ${(props) => (props.menuOpen ? "visible" : "hidden")};
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        overflow: hidden;
    }
`;

export const SidebarNav = styled.nav`
    ${theme.mixins.flexBetween};
    width: 100%;
    flex-direction: column;
    text-align: left;
    height: fit-content;
`;

export const SidebarNavList = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;
    text-align: left;
`;

export const SidebarNavItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 14px;
    width: 100%;

    #right-arrow {
        fill: ${theme.colors.white};
    }
`;

export const SidebarNavLink = styled.button<{
    isActive: boolean;
}>`
    color: ${theme.colors.white};
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    background: unset;
    ${({ isActive }) => ActiveLinkStyles(isActive)};
`;

export const ExternalNavLink = styled.a`
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
`;

export const AppAvatar = styled(Avatar)<{
    showSeparator?: boolean;
}>`
    z-index: 12;
    position: relative;
    cursor: pointer;
    transition: all 100ms ease-out;
    overflow: visible;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
`;

export const SidebarInnerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    background-color: ${theme.colors.purple.primary};
    margin-top: 66px;
`;

export const LogoutButton = styled.button`
    color: ${theme.colors.white};
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    background-color: unset;
`;

export const SidebarProfileItem = styled.div`
    color: ${theme.colors.white};
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    background-color: unset;
    width: 100%;
`;